import SermonView from './views/SermonView.vue'

export default [
  {
    path: '/sermon/:id',
    name: 'sermon',
    component: SermonView,
  },
]
